import React from 'react'

const TodayAttTable = ({todayAttData}) => {
    // console.log("todayAttData",todayAttData)
  return (
    <div className="bg-white dark:text-gray-100  dark:bg-gray-800 p-4 shadow rounded-lg md:col-span-3">
                {
                  <>
                    <h2 className="text-xl lg:text-2xl text-center pb-2 font-bold mb-6 border-b-2">Today Attendence</h2>
                    {/* <hr /> */}
                    <div className="max-h-64 overflow-y-auto">
                      <table className="w-full border-collapse border border-gray-200">
                        <thead>
                          <tr className="bg-gray-100 dark:bg-lightgrey border-gray-300">
                            <th className="border  p-2">Name</th>
                            <th className="border  p-2">TimeIn</th>
                            <th className="border  p-2">TimeOut</th>
                            <th className="border  p-2">Last Present</th>
                            <th className="border  p-2">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                          todayAttData?.length == 0 ? 
                          (<tr  className="bg-gray-50 dark:bg-darkgray h-64">
                          <td  colSpan={5} className="text-sm sm:text-base text-gray-800 dark:text-white text-center font-medium">
                           Attendance data is not available at the moment
                          </td>
                        </tr>)
                          :
                          todayAttData?.map((att, index) => {
                            // console.log("att.ATTENDANCE_STATUS",att.ATTENDANCE_STATUS)
                            // Determine status
                            let statusText = "Holiday";
                            if (att) {
                              if (att.ATTENDANCE_STATUS === "Absent") {
                                statusText = "Absent";
                              } else if (att.ATTENDANCE_STATUS === "Leave") {
                                statusText = "Leave";
                              } else if (att.ATTENDANCE_STATUS === "Late") {
                                statusText = "Late";
                              } else if (att.ATTENDANCE_STATUS === "Present") {
                                statusText = "Present";
                              }
                               else if (att.ATTENDANCE_STATUS === "Time Not Started") {
                                statusText = "Time Not Started";
                              } 
                               else if (att.ATTENDANCE_STATUS === "Off") {
                                statusText = "Weekend";
                              }
                            }

                            let statusClass = "text-yellow-600 bg-yellow-100";
                            if (statusText === "Present") {
                              statusClass = "text-green-600 bg-green-100";
                            } else if (statusText === "Late") {
                              statusClass = "text-yellow-600 bg-yellow-100";
                            } else if (statusText === "Absent") {
                              statusClass = "text-red-600 bg-red-100";
                            } else if (statusText === "Leave") {
                              statusClass = "text-blue-600 bg-blue-100";
                            }
                              else if (statusText === "Time Not Started") {
                              statusClass = "text-purple-600 bg-purple-100";
                            }
                              else if (statusText === "Weekend") {
                              statusClass = "text-blue-600 bg-blue-100";
                            }

                            return (
                              <tr key={index} className="text-center">
                                <td className="border border-gray-300 p-2">{att.NAME}</td>
                                <td className="border border-gray-300 p-2">{att?.ENTRYTIME || "-"}</td>
                                <td className="border border-gray-300 p-2">
                                  {att?.ENTRYTIME && att?.LEAVEINGTIME == null ? "Still In" : (att?.LEAVEINGTIME || "-")}
                                </td>
                                <td className="border border-gray-300 p-2">
                                  {att.LAST_PRESENT}
                                </td>
                                <td className="border border-gray-300 p-2">
                                  <span className={`px-2 py-1 text-sm font-semibold rounded-lg ${statusClass}`}>
                                    {statusText}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}

                        </tbody>
                      </table>

                    </div>
                  </>
                }
              </div>
)
}

export default TodayAttTable